import { Alert, Snackbar } from '@mui/material';
import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { DropzoneAreaBase } from 'react-mui-dropzone';

const MyUploader = ({ defaultValue, rules, name, control, filesLimit, acceptedFiles, label }) => {
    const [mensaje, setMensaje] = useState({ open: false, value: '', estatus: 'error' });
    const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
    const handleAdd = (onChange, files) => (newFiles) => {
        onChange(files.concat(newFiles));
    };
    const handleDelete = (onChange, files) => (deleted) => {
        onChange(files.filter((f) => f !== deleted));
    };
    return (
        <>
            <Controller
                defaultValue={defaultValue || []}
                rules={rules || {}}
                name={name}
                control={control}
                render={({ field }) => (
                    <DropzoneAreaBase
                        dropzoneText="Agregar evidencia(s)"
                        filesLimit={filesLimit}
                        acceptedFiles={acceptedFiles}
                        inputProps={{ title: 'Solo puede agregar un archivo multimedia' }}
                        maxFileSize={996147200}
                        fileObjects={field.value}
                        onAdd={handleAdd(field.onChange, field.value)}
                        onDelete={handleDelete(field.onChange, field.value)}
                        showAlerts={[]}
                        dropzoneProps={{
                            disabled: field.value.length == 1
                        }}
                        onAlert={(message, variant) => {
                            let mensaje = '';
                            if (variant == 'error') {
                                if (message.includes('File type not supported')) mensaje += 'Archivo inválido. ';
                                if (message.includes('Maximum allowed number'))
                                    mensaje += `Se excedió el número máximo de archivos, solo se permite ${filesLimit} archivo(s). `;
                                if (message.includes('File is too big')) mensaje += 'El archivo no pueden pesar más de 700 MB. ';
                            } else {
                                mensaje = 'Evidencia lista para enviar';
                            }
                            setMensaje({ open: true, estatus: variant, value: mensaje });
                            // switch (variant) {
                            //     case 'error':
                            //         if (message.includes('File type not supported')) message = 'Formato invalido';
                            //         else if (message.includes('Maximum allowed number'))
                            //             message = `Se excedió el número máximo de archivos, solo se permite ${filesLimit} archivo(s)`;
                            //         setMensaje({ open: true, estatus: variant, value: message });
                            //         break;
                            //     default:
                            //         break;
                            // }
                        }}
                    />
                )}
            />
            <Snackbar open={mensaje.open} autoHideDuration={4000} onClose={cerrarMensaje}>
                <Alert onClose={cerrarMensaje} variant="filled" severity={mensaje.estatus}>
                    {mensaje.value}
                </Alert>
            </Snackbar>
        </>
    );
};
MyUploader.defaultProps = {
    filesLimit: 1,
    acceptedFiles: ['video/*']
};

export default MyUploader;
